import gql from "graphql-tag";

export const ADD_DEFAULT_ROLE = gql`
  mutation AddDefaultRole($name: String!, $hourlyRate: Int!) {
    addDefaultRole(name: $name, hourlyRate: $hourlyRate) {
      status
      error
      data {
        id
        name
        hourlyRate
      }
    }
  }
`;

export const UPDATE_DEFAULT_ROLE = gql`
  mutation UpdateDefaultRole($id: ID!, $name: String, $hourlyRate: Int) {
    updateDefaultRole(id: $id, name: $name, hourlyRate: $hourlyRate) {
      status
      error
      data {
        id
        name
        hourlyRate
      }
    }
  }
`;

export const DELETE_DEFAULT_ROLES = gql`
  mutation DeleteDefaultRoles($ids: [ID!]!) {
    deleteDefaultRoles(ids: $ids) {
      status
      error
      data {
        id
        name
        hourlyRate
      }
    }
  }
`;
